import { read, write } from './storage';

/**
 * Invite attribution. A `?ref=CODE` link (or a Mini App opened with start_param `ref_CODE`) is
 * remembered for 30 days on this device and sent with the sign-up. The latest link wins.
 */
const KEY = 'edil.ref';
const TTL_MS = 30 * 86_400_000;
const CODE = /^[A-Z0-9_]{3,32}$/;

export function normalizeCode(raw: string | null | undefined): string | null {
  const code = (raw ?? '').trim().toUpperCase();
  return CODE.test(code) ? code : null;
}

/** Remembers a code from the URL or the Mini App start parameter; returns it when it is new. */
export function captureReferral(search: string, startParam?: string): string | null {
  const fromStart = /^ref_(\w{3,32})$/i.exec(startParam ?? '')?.[1];
  const code = normalizeCode(new URLSearchParams(search).get('ref') ?? fromStart);
  if (!code) return null;
  const isNew = storedReferral() !== code;
  write(KEY, JSON.stringify({ code, at: Date.now() }));
  return isNew ? code : null;
}

export function storedReferral(): string | null {
  try {
    const v = JSON.parse(read(KEY) ?? 'null') as { code: string; at: number } | null;
    return v && Date.now() - v.at < TTL_MS ? normalizeCode(v.code) : null;
  } catch {
    return null;
  }
}

export function clearReferral(): void {
  write(KEY, null);
}
